import { setPartnerSites } from 'app/reducers/apiKeySlice';
import apiKeysService from 'app/services/apiKeys.service';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { IPartnerOAuthComponent } from './types';
import { useHistory  } from 'react-router-dom';
import { IVenue } from 'app/reducers/venueSlice';
import { IconButton, Snackbar } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import Alert from '@material-ui/lab/Alert';

const NS = 'PartnerOAuthComponent';

const initialState: any = {
  locationId: null,
  venueId: null,
  isLoading: true, 
  accessToken: null,
  isPartnerSiteLoading: true,
  openErrorSnackbar: false,
  errorMessage: null
};

export default function PartnerOAuthComponent({ handleSomeClick}: IPartnerOAuthComponent) {
  const dispatch = useDispatch();
  const history = useHistory();  
  const [state, setState] = useState<any>(initialState);
  
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const queryParamState = decodeURIComponent(params.get('state'));

    const error = params.get('error');
    const errorDescription = params.get('error_description');

    if (error?.length > 0){
      setState({...state, isLoading: false, isPartnerSiteLoading: false, openErrorSnackbar: true, errorMessage: errorDescription});
    } else {
      const code = params.get('code');
      
      const selectedVenue = JSON.parse(localStorage.getItem('selectedVenue')) as IVenue;
      const selectedVenueId = selectedVenue?.id;
      const selectedLocationIdString = localStorage.getItem(`Integration_Id`);
      const storedState = localStorage.getItem(`Partner_${selectedVenueId}_${selectedLocationIdString}_state`);

      if (storedState && queryParamState && storedState === queryParamState) {
        const theLocationId = parseInt(selectedLocationIdString);

        setState({...state, locationId: theLocationId, venueId: selectedVenueId});
        if (selectedVenueId > 0 && theLocationId > 0) {
          apiKeysService.postOAuthFlowToGetAccessToken(selectedVenueId, theLocationId, code)
            .then((result) => {
              setState({...state, accessToken: result.access_token, refreshToken: result.refresh_token, isLoading: false});
            })
            .then(() => {
              // Get all the sites
              apiKeysService.getPartnerSites(selectedVenueId, theLocationId)
                .then((partnerSites) => {
                  dispatch(setPartnerSites(partnerSites));
                  console.log(`redirecting to api key item ${theLocationId}`);
                  history.push(`/apikeys/${theLocationId}`);
                })
                .catch((error) => {
                  console.error(error);
                  setState({...state, openErrorSnackbar: true, errorMessage: 'Failed to retrieve Partner Sites.'});
                });
            })
            .catch((error) => {
              console.error(error);
              setState({...state, openErrorSnackbar: true, errorMessage: 'Failed to complete OAuth Handshake.'});
            });
        }
      } else {
        setState({...state, isLoading: false, isPartnerSiteLoading: false, openErrorSnackbar: true, errorMessage: 'Invalid state.'});
      }
    }
  }, [dispatch]);

  const handleSnackbarClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setState({...state, openErrorSnackbar: false, errorMessage: null});
    history.push('/apikeys');
  }

  return (<div>
    <Snackbar 
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={state.openErrorSnackbar}
      autoHideDuration={3000}
      onClose={handleSnackbarClose}
      action={
        <>
          <IconButton size="small" aria-label="close" color="inherit" onClick={handleSnackbarClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      }
    >
        <Alert onClose={handleSnackbarClose} severity="error">
          {state.errorMessage}
        </Alert>
    </Snackbar>
  </div>)
}